"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var BASE_URL = '/email/v1/optin/portals/form-and-page-settings';

var DoiPagesAPI =
/*#__PURE__*/
function () {
  function DoiPagesAPI() {
    (0, _classCallCheck2.default)(this, DoiPagesAPI);
  }

  (0, _createClass2.default)(DoiPagesAPI, null, [{
    key: "get",
    value: function get() {
      return _apiClient.default.get(BASE_URL, {
        query: {
          activeOnly: true
        }
      });
    }
  }, {
    key: "update",
    value: function update(page) {
      return _apiClient.default.put(BASE_URL, {
        query: page
      });
    }
  }]);
  return DoiPagesAPI;
}();

exports.default = DoiPagesAPI;
module.exports = exports.default;